export default __webpack_public_path__ + "static/media/schedule.d2a8b7d6.svg";